import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'ds-simple-pagination',
  templateUrl: './simple-pagination.component.html',
  styleUrls: ['./simple-pagination.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SimplePaginationComponent,
      multi: true
    }
  ],
})
export class SimplePaginationComponent implements ControlValueAccessor {

  @Output() valueChanged: EventEmitter<number> = new EventEmitter<number>();

  @Input() disabled = false;
  @Input() lastPageIndex = 0;
  @Input() nextTitle = 'Next';
  @Input() previousTitle = 'Previous';
  @Input() pagesTitle = 'pages';
  @Input() ofTitle = 'of';

  /** Current page index. */
  @Input() set value(v: any) {
    if (v !== this.innerValue) {
      if (v > this.lastPageIndex) {
        v = this.lastPageIndex;
      }
      if (v < 0) {
        v = 0;
      }
      this.writeValue(v);
      if (this.onChangeCallback) {
        this.onChangeCallback(v);
      }
      this.valueChanged.emit(this.value);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  private onTouchedCallback: () => void;
  private onChangeCallback: (pageNumber: number) => void;

  protected innerValue = 0;

  registerOnChange(fn: (pageNumber: number) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value: number): void {
    this.innerValue = value;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectPrevious(): void {
    if (this.value > 0) {
      this.value = this.value - 1;
    }
  }

  selectNext(): void {
    if (this.value < this.lastPageIndex) {
      this.value = this.value + 1;
    }
  }
}
